var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.876953 7.48503C0.876953 3.80569 3.86362 0.818359 7.54361 0.818359C11.2303 0.818359 14.2103 3.80569 14.2103 7.48503C14.2103 11.1657 11.2303 14.1517 7.54361 14.1517C3.86362 14.1517 0.876953 11.1657 0.876953 7.48503ZM6.95694 4.95836C6.95694 4.63903 7.22361 4.37169 7.54361 4.37169C7.86361 4.37169 8.12361 4.63903 8.12361 4.95836V7.90503C8.12361 8.22569 7.86361 8.48503 7.54361 8.48503C7.22361 8.48503 6.95694 8.22569 6.95694 7.90503V4.95836ZM7.55027 10.6057C7.22361 10.6057 6.96361 10.339 6.96361 10.019C6.96361 9.69903 7.22361 9.43902 7.54361 9.43902C7.87027 9.43902 8.13027 9.69903 8.13027 10.019C8.13027 10.339 7.87027 10.6057 7.55027 10.6057Z",
    fill: "#FFA927"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.1140ed700da89bab679c4b0d6ac592a0.svg";
export { ForwardRef as ReactComponent };